import PropTypes from "prop-types";

/**
 * Floating action button with customizable color, background, icon, and optional message.
 *
 * @param root0 - The component props.
 * @param root0.color - The icon color.
 * @param root0.backgroundColor - The button background color.
 * @param root0.onClick - The click event handler.
 * @param root0.icon - The icon element to render.
 * @param root0.message - An optional tooltip message.
 * @returns The rendered float button component.
 */
const FloatButton = ({
    color = "#000",
    backgroundColor = "#FFF",
    onClick,
    icon,
    message = "",
}) => {
    const style = {
        color,
        backgroundColor,
        borderColor: color,
    };

    return (
        <div className="float-button">
            <div
                className={`float-button-message ${message ? "opened" : ""}`}
                style={style}
            >
                {message}
            </div>
            <div className="float-button-icon" onClick={onClick} style={style}>
                <img src={icon} width={65} height={65} />
            </div>
        </div>
    );
};

FloatButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    icon: PropTypes.string.isRequired,
    message: PropTypes.string,
    color: PropTypes.string,
    backgroundColor: PropTypes.string,
};

export default FloatButton;
